<template>
  <div class="mt-4">
    <BaseFormModal ref="base" name="verCodigoParceiroModal" :centered="true" @show="onShow">
      <template #title>
        {{ $t("codigo", 2) }}
      </template>
      <template #body>
        <CodigoParceiroTable ref="codigoParceiroTable" :id-parceiro="id" />
      </template>
      <template #footer>
        <button type="button" class="btn btn-primary" @click="$refs.base.hide()">
          {{ $t("concluido") }}
        </button>
      </template>
    </BaseFormModal>
  </div>
</template>

<script>
import BaseFormModal from '@/modules/core/components/BaseFormModal.vue';
import CodigoParceiroTable from './CodigoParceiroTable.vue';
import eventbus from '@/modules/core/services/eventbus';
export default {
  components: { BaseFormModal, CodigoParceiroTable },
  props: {
    id: { type: String, required: true },
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    onShow() { eventbus.emit('reload-codigo'); },
    show() { this.$refs.base.show(); },
    hide() { this.$refs.base.hide(); },
  },
};
</script>

<style scoped>
.mw-120 {
  min-width: 120px;
}
</style>
